import React, { useState, useEffect } from "react";
import { Modal, Checkbox, Typography, Button, message, Input } from "antd";
import { typeMap3 } from "@/constants/dataMap";
import { simulation } from "@/services/common";
import userInfo from "@/Components/user";
import { useAppContext } from "@/AppContext";
import newInput from "@/constants/newInput.json";
import newInput2 from "@/constants/newInput2.json";
import { fieldMap2, typeMap2, unitMap, dataTypeMap } from "@/constants/dataMap";
import towerJson from "@/Components/Diagram/elementsData/tower.json";
import { validateInput } from "./validateInput";
import {buildTaskInput as newBuildTaskInput} from "@/Pages/Project/Flow/FlowDesign/func/buildInput"

import heatExchanger from "./elementsData/heatExchanger.json";

const { Text } = Typography;

// 构建提交数据的函数（从 FlowDesign 的 handleData 提取）
export const buildTaskInput = (jsonData: any, selectedElements: string[], state: any) => 
{
  const flowId = state.curFlow["id"];
  const flowName = state.curFlow["name"];
  const flowDes = state.curFlow["description"] || "";
  const globlePhysicalMethod = state.globle_physical_method;

  let elements = [];
  let streams = [];
  let desElements = [];
  let desStreams = [];
  let inputStreamsMap = {};
  let outputStreamsMap = {};
  let groupsMap = {};

  // 处理 group 数据
  let groupDatas = jsonData.nodeDataArray.filter((item: any) => item.isGroup);
  for (let i = 0; i < groupDatas.length; i++) {
    let groupKey = groupDatas[i].key;
    let groupName = groupDatas[i].keywords;
    groupsMap[groupKey] = groupName;
  }

  // 处理 streams 数据
  for (let i = 0; i < jsonData.linkDataArray.length; i++) {
    let linkData = jsonData.linkDataArray[i];
    if (linkData.linkName && linkData.linkName !== "") {
      let streamsNmae = linkData.linkName;
      let streamsSection = "";
      let streamsType = "";
      let streamAttribute = "";
      let streamsFrom = linkData.from;
      let streamsTo = linkData.to;
      let streamsFromPort = linkData.fromPort;
      let streamsToPort = linkData.toPort;

      let streamsParams = {};
      let desStreamsParams = {};
      if (linkData.ParamValues) {
        for (let key in linkData.ParamValues) {
          let field = key;
          if (linkData.ParamValues[key].engName && linkData.ParamValues[key].engName !== "") {
            field = linkData.ParamValues[key].engName;
          } else {
            if (fieldMap2[key] !== undefined) {
              field = fieldMap2[key];
            }
          }

          if (field === "type") {
            streamsType = linkData.ParamValues[key].value;
            continue;
          }
          if (field === "streamAttribute") {
            streamAttribute = linkData.ParamValues[key].value;
            continue;
          }

          if (linkData.ParamValues[key].unit) {
            let value = linkData.ParamValues[key].value;
            let desValue = linkData.ParamValues[key].desValue;
            let engName = linkData.ParamValues[key].engName;
            if (dataTypeMap[engName] && dataTypeMap[engName] === "number") {
              if (value !== "") {
                value = Number(value);
                if (Number.isNaN(value)) value = null;
              } else {
                value = null;
              }

              if (desValue !== "") {
                desValue = Number(desValue);
                if (Number.isNaN(desValue)) desValue = null;
              } else {
                desValue = null;
              }
            } else if (dataTypeMap[engName] && dataTypeMap[engName] === "string") {
              if (value === "") value = null;
              if (desValue === "") desValue = null;
            }

            streamsParams[field] = value;
            desStreamsParams[field] = desValue;

            if (linkData.ParamValues[key].unitField !== undefined) {
              if (linkData.ParamValues[key].unitField !== null) {
                if (linkData.ParamValues[key].unitField === "") {
                  streamsParams[`${field}_unit`] = linkData.ParamValues[key].unit;
                  desStreamsParams[`${field}_unit`] = linkData.ParamValues[key].unit;
                } else {
                  streamsParams[linkData.ParamValues[key].unitField] =
                    linkData.ParamValues[key].unit;
                  desStreamsParams[`${field}_unit`] = linkData.ParamValues[key].unit;
                }
              }
            }
          } else {
            let value = linkData.ParamValues[key].value;
            let desValue = linkData.ParamValues[key].desValue;
            let engName = linkData.ParamValues[key].engName;
            if (dataTypeMap[engName] && dataTypeMap[engName] === "number") {
              if (value !== "") {
                value = Number(value);
                if (Number.isNaN(value)) value = null;
              } else {
                value = null;
              }

              if (desValue !== "") {
                desValue = Number(desValue);
                if (Number.isNaN(desValue)) desValue = null;
              } else {
                desValue = null;
              }
            } else if (dataTypeMap[engName] && dataTypeMap[engName] === "string") {
              if (value === "") value = null;
              if (desValue === "") desValue = null;
            }

            streamsParams[field] = value;
            desStreamsParams[field] = desValue;
          }
        }
      }

      let materials = [];
      let desMaterials = [];
      if (linkData.materials) {
        for (let key in linkData.materials) {
          let molarFrac = linkData.materials[key].molar_frac;
          if (molarFrac !== "") {
            molarFrac = Number(molarFrac);
            if (Number.isNaN(molarFrac)) molarFrac = null;
          } else {
            molarFrac = null;
          }
          let material = {
            cas: linkData.materials[key].cas,
            molar_frac: molarFrac,
            name: linkData.materials[key].name,
          };
          materials.push(material);

          let desValue = linkData.materials[key].desValue;
          if (desValue !== "") {
            desValue = Number(desValue);
            if (Number.isNaN(desValue)) desValue = null;
          } else {
            desValue = null;
          }
          let desMaterial = {
            cas: linkData.materials[key].cas,
            molar_frac: desValue,
            name: linkData.materials[key].name,
          };
          desMaterials.push(desMaterial);
        }
      }

      let inputStreamMap = {
        name: streamsNmae,
        rule: streamsToPort,
        streamAttribute: streamAttribute,
      };
      if (!inputStreamsMap[streamsTo]) inputStreamsMap[streamsTo] = [];
      inputStreamsMap[streamsTo].push(inputStreamMap);

      let outputStreamMap = {
        name: streamsNmae,
        rule: streamsFromPort,
        streamAttribute: streamAttribute,
      };
      if (!outputStreamsMap[streamsFrom]) outputStreamsMap[streamsFrom] = [];
      outputStreamsMap[streamsFrom].push(outputStreamMap);

      if (
        jsonData.nodeDataArray.filter((item: any) => !item.isGroup && item.key === streamsFrom)
          .length > 0
      ) {
        let streamsFromElement = jsonData.nodeDataArray.filter(
          (item: any) => !item.isGroup && item.key === streamsFrom,
        )[0];
        if (streamsFromElement && streamsFromElement.group) {
          streamsSection = groupsMap[streamsFromElement.group];
        }
      }
      if (streamsSection === "") {
        if (
          jsonData.nodeDataArray.filter((item: any) => !item.isGroup && item.key === streamsTo)
            .length > 0
        ) {
          let streamsToElement = jsonData.nodeDataArray.filter(
            (item: any) => !item.isGroup && item.key === streamsTo,
          )[0];
          if (streamsToElement && streamsToElement.group) {
            streamsSection = groupsMap[streamsToElement.group];
          }
        }
      }

      let toElementName =
        jsonData.nodeDataArray.find((item:any) => !item.isGroup && item.key === streamsTo)?.nodeName ??
        "";
      let fromElementName =
        jsonData.nodeDataArray.find((item:any) => !item.isGroup && item.key === streamsFrom)
          ?.nodeName ?? "";

      if (selectedElements.includes(toElementName) || selectedElements.includes(fromElementName)) {
        let stream = {
          name: streamsNmae,
          section: streamsSection,
          type: streamsType,
          params: streamsParams,
          materials: materials,
        };
        streams.push(stream);

        let desStream = {
          name: streamsNmae,
          section: streamsSection,
          type: streamsType,
          params: desStreamsParams,
          materials: desMaterials,
        };
        desStreams.push(desStream);
      }
    }
  }

  // 处理 elements 数据
  for (let i = 0; i < jsonData.nodeDataArray.length; i++) {
    let nodeData = jsonData.nodeDataArray[i];
    if (nodeData.elementName && nodeData.elementName !== "") {
      let elementNmae = nodeData.nodeName;
      let elementPhysicalMethod = nodeData.physical_method;
      let elementPhase = nodeData.phase;
      let elementMode = nodeData.mode;
      let elementKey = nodeData.key;
      let elementSection = nodeData.group ? nodeData.group : "";
      let elemnetInputStreams = [];
      let elemnetOutputStreams = [];

      if (!selectedElements.includes(elementNmae)) continue;

      if (elementSection !== "") {
        if (groupsMap[elementSection]) {
          elementSection = groupsMap[elementSection];
        }
      }

      let elementType = nodeData.elementName;
      if (typeMap2[elementType]) {
        elementType = typeMap2[elementType];
      }

      if (elementType != undefined) {
        if (inputStreamsMap[elementKey]) {
          for (let j = 0; j < inputStreamsMap[elementKey].length; j++) {
            let streamsName = inputStreamsMap[elementKey][j].name;
            let streamsRule = inputStreamsMap[elementKey][j].rule;
            let streamAttribute = inputStreamsMap[elementKey][j].streamAttribute;

            if (nodeData.type === "DistilStrict" || nodeData.type === "Flash2") {
              if (streamsRule.length > 0) {
                if (streamsRule[0] === "T") streamsRule = "D";
                else if (streamsRule[0] === "B") streamsRule = "B";
                else streamsRule = "M";
              } else {
                streamsRule = "M";
              }
            } else {
              streamsRule = "M";
            }
            elemnetInputStreams.push({ name: streamsName, rule: streamsRule ,streamAttribute:streamAttribute });
          }
        }

        if (outputStreamsMap[elementKey]) {
          for (let j = 0; j < outputStreamsMap[elementKey].length; j++) {
            let streamsName = outputStreamsMap[elementKey][j].name;
            let streamsRule = outputStreamsMap[elementKey][j].rule;
            let streamAttribute = outputStreamsMap[elementKey][j].streamAttribute;

            if (nodeData.type === "DistilStrict" || nodeData.type === "Flash2") {
              if (streamsRule.length > 0) {
                if (streamsRule[0] === "T") streamsRule = "D";
                else if (streamsRule[0] === "B") streamsRule = "B";
                else streamsRule = "M";
              } else {
                streamsRule = "M";
              }
            } else {
              streamsRule = "M";
            }
            elemnetOutputStreams.push({ name: streamsName, rule: streamsRule ,streamAttribute:streamAttribute });
          }
        }

        let elementParams = {};
        let desElementParams = {};
        if (nodeData.ParamValues) {
          for (let key in nodeData.ParamValues) {
            let field = key;
            if (nodeData.ParamValues[key].engName && nodeData.ParamValues[key].engName !== "") {
              field = nodeData.ParamValues[key].engName;
            } else {
              if (fieldMap2[key] !== undefined) field = fieldMap2[key];
            }

            if (nodeData.ParamValues[key].p_children) 
            {
              let children = [];
              let desChildren = [];
              for (let j = 0; j < nodeData.ParamValues[key].p_children.length; j++) {
                let childrenData = nodeData.ParamValues[key].p_children[j];
                let childrenParams = {};
                let desChildrenParams = {};
                for (let childrenKey in childrenData) {
                  let childrenfield = childrenKey;
                  if (
                    childrenData[childrenKey].engName &&
                    childrenData[childrenKey].engName !== ""
                  ) {
                    childrenfield = childrenData[childrenKey].engName;
                  } else {
                    if (fieldMap2[childrenKey] != undefined) childrenfield = fieldMap2[childrenKey];
                  }

                  if (childrenData[childrenKey].unit) {
                    let childrenValue = childrenData[childrenKey].value;
                    let desChildrenValue = childrenData[childrenKey].desValue;
                    let childrenEngName = childrenData[childrenKey].engName;

                    if (dataTypeMap[childrenEngName] && dataTypeMap[childrenEngName] === "number") {
                      if (childrenValue !== "") {
                        childrenValue = Number(childrenValue);
                        if (Number.isNaN(childrenValue)) childrenValue = null;
                      } else {
                        childrenValue = null;
                      }

                      if (desChildrenValue !== "") {
                        desChildrenValue = Number(desChildrenValue);
                        if (Number.isNaN(desChildrenValue)) desChildrenValue = null;
                      } else {
                        desChildrenValue = null;
                      }
                    } else if (
                      dataTypeMap[childrenEngName] &&
                      dataTypeMap[childrenEngName] === "string"
                    ) {
                      if (childrenValue === "") childrenValue = null;
                      if (desChildrenValue === "") desChildrenValue = null;
                    }

                    childrenParams[childrenfield] = childrenValue;
                    desChildrenParams[childrenfield] = desChildrenValue;
                  } else {
                    let childrenValue = childrenData[childrenKey].value;
                    let desChildrenValue = childrenData[childrenKey].desValue;
                    let childrenEngName = childrenData[childrenKey].engName;

                    if (dataTypeMap[childrenEngName] && dataTypeMap[childrenEngName] === "number") {
                      if (childrenValue !== "") {
                        childrenValue = Number(childrenValue);
                        if (Number.isNaN(childrenValue)) childrenValue = null;
                      } else {
                        childrenValue = null;
                      }

                      if (desChildrenValue !== "") {
                        desChildrenValue = Number(desChildrenValue);
                        if (Number.isNaN(desChildrenValue)) desChildrenValue = null;
                      } else {
                        desChildrenValue = null;
                      }
                    } else if (
                      dataTypeMap[childrenEngName] &&
                      dataTypeMap[childrenEngName] === "string"
                    ) {
                      if (childrenValue === "") childrenValue = null;
                      if (desChildrenValue === "") desChildrenValue = null;
                    }

                    childrenParams[childrenfield] = childrenValue;
                    desChildrenParams[childrenfield] = desChildrenValue;
                  }
                }
                children.push(childrenParams);

                desChildren.push(desChildrenParams);
              }

              // 特殊处理 DistilStrict 的 Ns/No
              if (nodeData.type === "DistilStrict" && (field === "Ns" || field === "No")) {
                children = [];
                desChildren = [];
                if (field === "Ns") {
                  for (let j = 0; j < elemnetInputStreams.length; j++) {
                    let childrenValue = null;
                    let desChildrenValue = null;
                    let childrenDatas = nodeData.ParamValues[key].p_children.filter(
                      (item: any) => item["流股"]?.value === elemnetInputStreams[j].name,
                    );
                    if (childrenDatas.length > 0) {
                      childrenValue = childrenDatas[0]["进料位置"]?.value;
                      childrenValue = Number(childrenValue);
                      if (Number.isNaN(childrenValue)) childrenValue = null;

                      desChildrenValue = childrenDatas[0]["进料位置"]?.desValue;
                      desChildrenValue = Number(desChildrenValue);
                      if (Number.isNaN(desChildrenValue)) desChildrenValue = null;
                    }
                    children.push(childrenValue);
                    desChildren.push(desChildrenValue);
                  }
                } else if (field === "No") {
                  for (let j = 0; j < elemnetOutputStreams.length; j++) {
                    let childrenValue = null;
                    let desChildrenValue = null;
                    let childrenDatas = nodeData.ParamValues[key].p_children.filter(
                      (item: any) => item["流股"]?.value === elemnetOutputStreams[j].name,
                    );
                    if (childrenDatas.length > 0) {
                      childrenValue = childrenDatas[0]["出料位置"]?.value;
                      childrenValue = Number(childrenValue);
                      if (Number.isNaN(childrenValue)) childrenValue = null;

                      desChildrenValue = childrenDatas[0]["出料位置"]?.desValue;
                      desChildrenValue = Number(desChildrenValue);
                      if (Number.isNaN(desChildrenValue)) desChildrenValue = null;
                    }
                    children.push(childrenValue);
                    desChildren.push(desChildrenValue);
                  }
                }
              }
              if (nodeData.type === "Splitter" && field === "output_f") {
                children = [];
                desChildren = [];
                for (let j = 0; j < elemnetOutputStreams.length; j++) {
                  let childrenValue = null;
                  let desChildrenValue = null;
                  let childrenDatas = nodeData.ParamValues[key].p_children.filter(
                    (item: any) => item["流股"]?.value === elemnetOutputStreams[j].name,
                  );
                  if (childrenDatas.length > 0) {
                    childrenValue = childrenDatas[0]["输出流量"]?.value;
                    childrenValue = Number(childrenValue);
                    if (Number.isNaN(childrenValue)) childrenValue = null;

                    desChildrenValue = childrenDatas[0]["输出流量"]?.desValue;
                    desChildrenValue = Number(desChildrenValue);
                    if (Number.isNaN(desChildrenValue)) desChildrenValue = null;
                  }
                  children.push(childrenValue);
                  desChildren.push(desChildrenValue);
                }
              }
              if (nodeData.type === "DistilStrict" && field === "eff") {
                //字符串改数字
                children = children.map((obj) =>
                  Object.fromEntries(
                    Object.entries(obj).map(([k, v]) => [k, isNaN(Number(v)) ? null : Number(v)]),
                  ),
                );
                desChildren = desChildren.map((obj) =>
                  Object.fromEntries(
                    Object.entries(obj).map(([k, v]) => [k, isNaN(Number(v)) ? null : Number(v)]),
                  ),
                );

                for (let j = 0; j < children.length; j++) {
                  let specChildren = [];
                  let desSpecChildren = [];
                  if (
                    nodeData.ParamValues[key].p_children[j]["特殊效率"] &&
                    nodeData.ParamValues[key].p_children[j]["特殊效率"].show
                  ) {
                    for (
                      let k = 0;
                      k < nodeData.ParamValues[key].p_children[j]["特殊效率"].children.length;
                      k++
                    ) {
                      let specValue =
                        nodeData.ParamValues[key].p_children[j]["特殊效率"].children[k]["效率值"]
                          .value;
                      let specChild = [k + 1, isNaN(Number(specValue)) ? null : Number(specValue)];
                      specChildren.push(specChild);

                      let desSpecValue =
                        nodeData.ParamValues[key].p_children[j]["特殊效率"].children[k]["效率值"]
                          .desValue;
                      let desSpecChild = [
                        k + 1,
                        isNaN(Number(desSpecValue)) ? null : Number(desSpecValue),
                      ];
                      desSpecChildren.push(desSpecChild);
                    }
                  }
                  children[j].spec = specChildren;
                  desChildren[j].spec = desSpecChildren;
                }
              }
              if (
                nodeData.type === "ShellAndTubeExchanger" &&
                (field === "cold_out_T" ||
                  field === "hot_out_T" ||
                  field === "cold_out_P" ||
                  field === "hot_out_P")
              ) 
              {
                let streamType = [];
                let unitField = heatExchanger
                  .find((item) => item.nodeName === nodeData.elementName)
                  .params.find((item) => item.p_engName === field)
                  .p_children.find((item) => item["p_unitField"])["p_unitField"];
                let type = heatExchanger
                  .find((item) => item.nodeName === nodeData.elementName)
                  .params.find((item) => item.p_engName === field)
                  .p_children.find((item) => item["p_type"])["p_type"];
                if (nodeData.ParamValues["流股属性"]) {
                  let streamAttribute = nodeData.ParamValues["流股属性"].value;
                  if (streamAttribute === "冷流股") {
                    if (field === "hot_out_T" || field === "hot_out_P") {
                      continue;
                    }
                  } else if (streamAttribute === "热流股") {
                    if (field === "cold_out_T" || field === "cold_out_P") {
                      continue;
                    }
                  } else {
                    if (field === "cold_out_T" || field === "hot_out_T") {
                      field = "out_T";
                    } else if (field === "cold_out_P" || field === "hot_out_P") {
                      field = "out_P";
                    }
                    children = [];
                    desChildren = [];
                    elementParams[field] = children;
                    elementParams["stream_type"] = streamType;
                    elementParams[unitField] = unitMap[type]?.[0];

                    desElementParams[field] = desChildren;
                    desElementParams["stream_type"] = streamType;
                    desElementParams[unitField] = unitMap[type]?.[0];
                    continue;
                  }
                  let newChildren = [];
                  let desNewChildren = [];
                  for (let j = 0; j < elemnetOutputStreams.length; j++) {
                    let child = children.find(
                      (item) => item.streamName === elemnetOutputStreams[j].name,
                    );
                    let desChild = desChildren.find(
                      (item) => item.streamName === elemnetOutputStreams[j].name,
                    );
                    if (child) {
                      let childValue =
                        child[
                          field === "cold_out_T" || field === "hot_out_T" ? "出口温度" : "出口压力"
                        ];
                      if (childValue !== "") {
                        childValue = Number(childValue);
                        if (Number.isNaN(childValue)) childValue = null;
                      } else {
                        childValue = null;
                      }

                      streamType.push(streamAttribute === "冷流股" ? "cold" : "hot");
                      newChildren.push(childValue);

                      if (desChild) {
                        let desChildValue =
                          desChild[
                            field === "cold_out_T" || field === "hot_out_T"
                              ? "出口温度"
                              : "出口压力"
                          ];
                        if (desChildValue !== "") {
                          desChildValue = Number(desChildValue);
                          if (Number.isNaN(desChildValue)) desChildValue = null;
                        } else {
                          desChildValue = null;
                        }

                        desNewChildren.push(desChildValue);
                      }
                    } else {
                      //判断该流股属性是否为"无"
                      let link = jsonData.linkDataArray.find(
                        (item:any) => item.linkName === elemnetOutputStreams[j].name,
                      );
                      if (
                        link.ParamValues["流股属性"] &&
                        link.ParamValues["流股属性"].value !== "无"
                      ) {
                        let childValue = null;
                        streamType.push(streamAttribute === "冷流股" ? "hot" : "cold");
                        newChildren.push(childValue);

                        let desChildValue = null;
                        desNewChildren.push(desChildValue);
                      }
                    }
                  }
                  elementParams["stream_type"] = streamType;
                  elementParams[unitField] =
                    nodeData.ParamValues[key].p_children[0][
                      field === "cold_out_T" || field === "hot_out_T" ? "出口温度" : "出口压力"
                    ].unit;

                  desElementParams["stream_type"] = streamType;
                  desElementParams[unitField] =
                    nodeData.ParamValues[key].p_children[0][
                      field === "cold_out_T" || field === "hot_out_T" ? "出口温度" : "出口压力"
                    ].unit;

                  children = newChildren;
                  desChildren = desNewChildren;
                } else {
                  if (field === "cold_out_T" || field === "hot_out_T") {
                    field = "out_T";
                  } else if (field === "cold_out_P" || field === "hot_out_P") {
                    field = "out_P";
                  }
                  children = [];
                  desChildren = [];
                  elementParams["stream_type"] = streamType;
                  elementParams[unitField] = unitMap[type]?.[0];

                  desElementParams["stream_type"] = streamType;
                  desElementParams[unitField] = unitMap[type]?.[0];
                }
              }
              if (nodeData.type === "ShellAndTubeExchanger" && field === "stream_type") 
              {
                children = children[0];
                desChildren = desChildren[0];

                //初值给null
                children["stream_in_cold"] = null;
                children["stream_in_hot"] = null;
                children["stream_out_cold"] = null;
                children["stream_out_hot"] = null;
                desChildren["stream_in_cold"] = null;
                desChildren["stream_in_hot"] = null;
                desChildren["stream_out_cold"] = null;
                desChildren["stream_out_hot"] = null;
                
                // //唯一性校验
                // if(elemnetInputStreams.filter(item=>item.streamAttribute==="冷流股").length>1)
                // {
                //   errorMessage = `${elementNmae} 参数 ${field} 输入异常：冷流股入口数量大于1`;
                //   input["error"] = errorMessage;
                //   return input;
                // }
                // if(elemnetInputStreams.filter(item=>item.streamAttribute==="热流股").length>1)
                // {
                //   errorMessage = `${elementNmae} 参数 ${field} 输入异常：热流股入口数量大于1`;
                //   input["error"] = errorMessage;
                //   return input;
                // }
                // if(elemnetOutputStreams.filter(item=>item.streamAttribute==="冷流股").length>1)
                // {
                //   errorMessage = `${elementNmae} 参数 ${field} 输入异常：冷流股出口数量大于1`;
                //   input["error"] = errorMessage;
                //   return input;
                // }
                // if(elemnetOutputStreams.filter(item=>item.streamAttribute==="热流股").length>1)
                // {
                //   errorMessage = `${elementNmae} 参数 ${field} 输入异常：热流股出口数量大于1`;
                //   input["error"] = errorMessage;
                //   return input;
                // }

                for (let j = 0; j < elemnetInputStreams.length; j++) 
                {
                  if(elemnetInputStreams[j].streamAttribute==="冷流股")
                  {
                    children["stream_in_cold"] = j+1;
                    desChildren["stream_in_cold"] = j+1;
                  }
                  else if(elemnetInputStreams[j].streamAttribute==="热流股")
                  {
                    children["stream_in_hot"] = j+1;
                    desChildren["stream_in_hot"] = j+1;
                  }
                }

                for (let j = 0; j < elemnetOutputStreams.length; j++) 
                {
                  if(elemnetOutputStreams[j].streamAttribute==="冷流股")
                  {
                    children["stream_out_cold"] = j+1;
                    desChildren["stream_out_cold"] = j+1;
                  }
                  else if(elemnetOutputStreams[j].streamAttribute==="热流股")
                  {
                    children["stream_out_hot"] = j+1;
                    desChildren["stream_out_hot"] = j+1;
                  }
                }

                Object.keys(children).forEach(key => 
                {
                  if (!children[key]) 
                  {
                    delete children[key];
                  }
                });
                Object.keys(desChildren).forEach(key => 
                {
                  if (!desChildren[key]) 
                  {
                    delete desChildren[key];
                  }
                });
              }

              elementParams[field] = children;
              desElementParams[field] = desChildren;
            } 
            else 
            {
              if (nodeData.ParamValues[key].unit) {
                let value = nodeData.ParamValues[key].value;
                let desValue = nodeData.ParamValues[key].desValue;
                let engName = nodeData.ParamValues[key].engName;

                if (dataTypeMap[engName] && dataTypeMap[engName] === "number") {
                  if (value !== "" && value != null) {
                    value = Number(value);
                    if (Number.isNaN(value)) value = null;
                  } else {
                    value = null;
                  }

                  if (desValue !== "" && desValue != null) {
                    desValue = Number(desValue);
                    if (Number.isNaN(desValue)) desValue = null;
                  } else {
                    desValue = null;
                  }
                } else if (dataTypeMap[engName] && dataTypeMap[engName] === "string") {
                  if (value === "") value = null;
                  if (desValue === "") desValue = null;
                }

                //特殊处理
                if (nodeData.type === "Flash2" && (field === "t" || field === "vaporFraction")) {
                  if (elementMode === "TP") {
                    if (field === "vaporFraction") {
                      continue;
                    }
                  } else if (elementMode === "VP" || elementMode === "HP") {
                    if (field === "t") {
                      continue;
                    }
                  } else {
                    continue;
                  }
                }

                elementParams[field] = value;
                desElementParams[field] = desValue;

                if (nodeData.ParamValues[key].unitField !== undefined) {
                  if (nodeData.ParamValues[key].unitField !== null) {
                    if (nodeData.ParamValues[key].unitField === "") {
                      elementParams[`${field}_unit`] = nodeData.ParamValues[key].unit;
                      desElementParams[`${field}_unit`] = nodeData.ParamValues[key].unit;
                    } else {
                      elementParams[nodeData.ParamValues[key].unitField] =
                        nodeData.ParamValues[key].unit;
                      desElementParams[nodeData.ParamValues[key].unitField] =
                        nodeData.ParamValues[key].unit;
                    }
                  }
                }
              } else {
                let value = nodeData.ParamValues[key].value;
                let desValue = nodeData.ParamValues[key].desValue;
                let engName = nodeData.ParamValues[key].engName;

                if (dataTypeMap[engName] && dataTypeMap[engName] === "number") {
                  if (value !== "" && value != null) {
                    value = Number(value);
                    if (Number.isNaN(value)) value = null;
                  } else {
                    value = null;
                  }

                  if (desValue !== "" && desValue != null) {
                    desValue = Number(desValue);
                    if (Number.isNaN(desValue)) desValue = null;
                  } else {
                    desValue = null;
                  }
                } else if (dataTypeMap[engName] && dataTypeMap[engName] === "string") {
                  if (value === "") value = null;
                  if (desValue === "") desValue = null;
                }

                //特殊处理
                if (nodeData.type === "DistilStrict" && field === "type") {
                  let elementName = nodeData.elementName;
                  value = towerJson.filter((item: any) => item.nodeName === elementName)?.[0]?.type;
                  desValue = towerJson.filter((item: any) => item.nodeName === elementName)?.[0]
                    ?.type;
                }
                if (
                  nodeData.type === "DistilStrict" &&
                  (field === "trayType" || field === "packingType")
                ) {
                  if (nodeData.ParamValues["内部类型"]) {
                    if (nodeData.ParamValues["内部类型"].value === "塔板") {
                      if (field === "packingType") {
                        continue;
                      }
                    } else if (nodeData.ParamValues["内部类型"].value === "填料") {
                      if (field === "trayType") {
                        continue;
                      }
                    } else if (nodeData.ParamValues["内部类型"].value === "混合") {
                      //同时存在，不做处理
                    } else {
                      continue;
                    }
                  } else {
                    continue;
                  }
                }
                if (nodeData.type === "Flash2" && (field === "t" || field === "vaporFraction")) {
                  if (elementMode === "TP") {
                    if (field === "vaporFraction") {
                      continue;
                    }
                  } else if (elementMode === "VP" || elementMode === "HP") {
                    if (field === "t") {
                      continue;
                    }
                  } else {
                    continue;
                  }
                }
                if (field === "streamAttribute") {
                  continue;
                }

                elementParams[field] = value;
                desElementParams[field] = desValue;
              }
            }
          }
        }

        //特殊处理
        if (nodeData.type === "DistilStrict") {
          elementParams["V_list"] = { NV: [], W: [] };
          elementParams["L_list"] = { NL: [], U: [] };
          elementParams["Q_list"] = { NQ: [], QH: [] };
        }

        let element = {
          mode: elementMode,
          name: elementNmae,
          phase: elementPhase,
          physical_method: elementPhysicalMethod,
          section: elementSection,
          type: elementType,
          params: elementParams,
          inputStreams: elemnetInputStreams,
          outputStreams: elemnetOutputStreams,
        };
        elements.push(element);

        let desElement = {
          mode: elementMode,
          name: elementNmae,
          phase: elementPhase,
          physical_method: elementPhysicalMethod,
          section: elementSection,
          type: elementType,
          params: desElementParams,
          inputStreams: elemnetInputStreams,
          outputStreams: elemnetOutputStreams,
        };
        desElements.push(desElement);
      }
    }
  }

  let input = 
  {
    flow_id: flowId,
    name: flowName,
    description: flowDes,
    cal: "True",
    mix_input: {
      selected_blocks: selectedElements,
      global_physical_method: globlePhysicalMethod,
      elements: elements,
      streams: setStreamsType(elements, streams, jsonData),
    },
    // design_input: {
    //   elements: desElements,
    //   streams: setStreamsType(desElements, desStreams, jsonData),
    // },
  };

  return input;
};

const setStreamsType = (elements: any, streams: any, diagramData: any) => {
  // console.log('diagramData',diagramData);
  // console.log('elements',elements);
  // console.log('streams',streams);
  const { linkDataArray, nodeDataArray } = diagramData;

  let newStreams = [...streams];

  const elementMap: any = [];
  elements.forEach((element: any) => {
    const node = nodeDataArray.find((e: any) => e.nodeName === element.name);
    elementMap.push(node.key);
  });

  newStreams.forEach((stream: any) => {
    const link = linkDataArray.find((e: any) => e.linkName === stream.name);
    const { from, to } = link;
    if (elementMap.includes(from) && elementMap.includes(to)) {
      stream.type = "内部";
    } else if (elementMap.includes(from) && !elementMap.includes(to)) {
      stream.type = "出料";
    } else if (!elementMap.includes(from) && elementMap.includes(to)) {
      stream.type = "进料";
    }
  });
  return newStreams;
};

interface SelectElementsModalProps {
  visible: boolean;
  jsonData: any;
  onClose: () => void;
  onSuccess?: () => void;
  state: any;
  notificationApi?: any;
  notificationKey?: string;
  setActiveTab?: any;
  saveCurData?: any;
  setSelectNode?: any;
  setSelectLink?: any;
  setActivePanel?: any;
  scrollToElementTarget?: any;
}

const SelectElementsModal: React.FC<SelectElementsModalProps> = ({
  visible,
  jsonData,
  onClose,
  onSuccess,
  setActiveTab,
  saveCurData,
  setSelectNode,
  setSelectLink,
  state,
  notificationApi,
  notificationKey,
  setActivePanel,
  scrollToElementTarget,
}) => {
  const [selectedElements, setSelectedElements] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);
  const [taskName, setTaskName] = useState("");

  useEffect(() => {
    if (visible) {
      setSelectedElements([]);
    }
  }, [visible]);

  const handleSelectAll = (e: any) => {
    if (e.target.checked) {
      setSelectedElements(allItemNames);
    } else {
      setSelectedElements([]);
    }
  };

  const allItems = (jsonData?.nodeDataArray || []).filter(
    (item: any) => !item.isGroup && item.elementName && item.nodeName.trim() !== "",
  );
  const allItemNames = allItems.map((item: any) => item.nodeName);
  const isAllSelected = selectedElements.length === allItemNames.length && allItemNames.length > 0;
  const isIndeterminate =
    selectedElements.length > 0 && selectedElements.length < allItemNames.length;

  const groupMap = new Map<string, any[]>();
  allItems.forEach((item: any) => {
    const type = item.type || "未分类";
    if (!groupMap.has(type)) groupMap.set(type, []);
    groupMap.get(type)!.push(item);
  });

  const handleOk = async () => {
    // api.destroy(notificationKey);
    if (selectedElements.length === 0) {
      message.warning("请至少选择一个元件");
      return;
    }
    setLoading(true);

    try {
      const input = newBuildTaskInput(jsonData, selectedElements,state,"True",taskName,"creat");
      input.name = taskName;
      const token = userInfo.access_token;
      //暂时先提交测试数据
      // const tempupdate = {
      //   // name:input.name,
      //   name: taskName,
      //   mix_input: newInput.inputs,
      //   flow_id: state.curFlow["id"],
      //   cal: "True",
      //   description: "",
      // };
      // console.log("input:", input);
      if (taskName.trim() === "") {
        message.warning("请输入任务名称");
        return;
      }

      // console.log("validateInput:", validateInput(input.mix_input));
      const validInfo = validateInput(input["mix_input"]);
      if (validInfo === "ok") 
      {
        // const res = await simulation(newInput2, token);
        //没有错误信息
        // const res = await simulation(tempupdate, token);

        const res = await simulation(input, token);
        if (res.status === 200) {
          message.success("提交成功");
          onSuccess?.();
          onClose();
        } else {
          message.error(`提交失败：${res.status}`);
        }
      } else {
        openNotification(validInfo);
        return;
      }

    } catch (error) {
      message.error("提交异常");
    } finally {
      setLoading(false);
    }
  };

  //错误信息分组
  function groupErrors(data: any) {
    // 用对象做分组容器：key = name
    const group = {};

    data.forEach((item: any) => {
      const { name, type, field, fieldName, eleTypeName } = item;

      // 如果该 name 还没有分组，初始化
      if (!group[name]) {
        group[name] = {
          name,
          type,
          field: [],
          fieldName: [],
          eleTypeName,
        };
      }

      const target = group[name];

      // 自动去重：只添加不存在的字段
      if (!target.field.includes(field)) {
        target.field.push(field);
      }
      if (!target.fieldName.includes(fieldName)) {
        target.fieldName.push(fieldName);
      }
    });
    // 把分组对象转成数组返回
    return Object.values(group);
  }

  const openNotification = (validInfo: { elementsErrors: any; streamsErrors?: any }) => {
    onClose();
    let width = 500;
    const { elementsErrors, streamsErrors } = validInfo;
    let description: any = "";
    if (elementsErrors === "ok" && streamsErrors !== "ok") {
      const errors = groupErrors(streamsErrors);
      description = (
        <ul className="error-list">
          {errors.map((item: any, index: number) => {
            return (
              <li
                key={index}
                onClick={() => {
                  setActiveTab(item.type);
                  // saveCurData();
                  setSelectLink(item.name);
                  setTimeout(() => {
                    scrollToElementTarget("streams-container", `item-${item.name}`);
                  }, 100);
                }}
              >
                <span className="s">{index + 1}</span>进料流股<b>【{item.name}】</b>：
                <b style={{ color: "red" }}>{item.fieldName.join(",")}</b>参数有误
              </li>
            );
          })}
        </ul>
      );
    } else if (elementsErrors !== "ok" && streamsErrors === "ok") {
      const errors = groupErrors(elementsErrors);
      description = (
        <ul className="error-list">
          {errors.map((item: any, index: number) => {
            return (
              <li
                key={index}
                onClick={() => {
                  setActiveTab(item.type);
                  setActivePanel(item.eleTypeName);
                  // saveCurData();
                  setSelectNode(item.name);
                  setTimeout(() => {
                    scrollToElementTarget(item.eleTypeName, `item-${item.name}`);
                  }, 500);
                }}
              >
                <span className="e">{index + 1}</span>
                <b>{item.name}</b>：<b style={{ color: "red" }}>{item.fieldName.join(",")}</b>
                参数有误
              </li>
            );
          })}
        </ul>
      );
    } else {
      // width = 1000;
      const e_errors = groupErrors(elementsErrors);
      const s_errors = groupErrors(streamsErrors);
      description = (
        // <div className="error-description">
            <ul className="error-list">
              {e_errors.map((item: any, index: number) => {
                return (
                  <li
                    key={index}
                    onClick={() => {
                      setActiveTab(item.type);
                      setActivePanel(item.eleTypeName);
                      // saveCurData();
                      setSelectNode(item.name);
                      setTimeout(() => {
                        scrollToElementTarget(item.eleTypeName, `item-${item.name}`);
                      }, 500);
                    }}
                  >
                    <span className="e">{index + 1}</span>
                    <b>{item.name}</b>：<b style={{ color: "red" }}>{item.fieldName.join(",")}</b>
                    参数有误
                  </li>
                );
              })}
              {s_errors.map((item: any, index: number) => {
                return (
                  <li
                    key={index}
                    onClick={() => {
                      setActiveTab(item.type);
                      // saveCurData();
                      setSelectLink(item.name);
                      setTimeout(() => {
                        scrollToElementTarget("streams-container", `item-${item.name}`);
                      }, 100);
                    }}
                  >
                    <span className="s">{e_errors.length+index + 1}</span>进料流股<b>【{item.name}】</b>：
                    <b style={{ color: "red" }}>{item.fieldName.join(",")}</b>参数有误
                  </li>
                );
              })}
            </ul>
         
        // </div>
      );
    }

    notificationApi?.warning({
      key: notificationKey,
      message: <b>参数设置错误</b>,
      description: description,
      placement: "topRight",
      duration: 0,
      style: {
        width: width,
      },
    });
  };

  return (
    <Modal
      title="提交任务"
      open={visible}
      onCancel={onClose}
      footer={[
        <Button key="cancel" onClick={onClose}>
          取消
        </Button>,
        <Button key="submit" type="primary" loading={loading} onClick={handleOk}>
          确认
        </Button>,
      ]}
      width={520}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          flexDirection: "row",
          marginBottom: 10,
          paddingBottom: 10,
          borderBottom: "1px solid #EEE",
        }}
      >
        <div style={{ fontSize: 14, color: "#000", marginRight: 20 }}>任务名称</div>
        <Input
          onChange={(e) => {
            setTaskName(e.target.value);
          }}
          style={{ flex: 1 }}
        />
      </div>
      <div
        style={{
          fontSize: 14,
          color: "#1b6ae7",
          fontWeight: "bold",
          marginBottom: 10,
          paddingBottom: 10,
          borderBottom: "1px solid #EEE",
        }}
      >
        选择需要提交的元件
      </div>
      <div style={{ marginBottom: 16 }}>
        <Checkbox
          indeterminate={isIndeterminate}
          checked={isAllSelected}
          onChange={handleSelectAll}
        >
          全选
        </Checkbox>
      </div>
      <Checkbox.Group
        value={selectedElements}
        style={{ width: "100%", maxHeight: 300, overflowY: "auto", marginBottom: 20 }}
        onChange={(vals) => setSelectedElements(vals as string[])}
      >
        {Array.from(groupMap.entries()).map(([type, items]) => (
          <div key={type}>
            <div style={{ fontWeight: "bold", marginBottom: 10, color: "#1b6ae7" }}>
              {typeMap3[type] || type}
            </div>
            <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center" }}>
              {items.map((item) => (
                <div key={item.key} style={{ flex: "0 0 auto", width: 150, marginBottom: 10 }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      overflow: "hidden",
                    }}
                  >
                    <Checkbox value={item.nodeName} style={{ marginRight: 8 }} />
                    <Text ellipsis={{ tooltip: item.nodeName }}>{item.nodeName}</Text>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </Checkbox.Group>
    </Modal>
  );
};

export default SelectElementsModal;
